import _mapiClient from "../../lib/classes/mapi-client";
import _client from "../../lib/client";
var exports = {};
var MapiClient = _mapiClient; // This will create the environment-appropriate client.

var createClient = _client;

function createServiceFactory(ServicePrototype) {
  return function (clientOrConfig) {
    var client;

    if (MapiClient.prototype.isPrototypeOf(clientOrConfig)) {
      client = clientOrConfig;
    } else {
      client = createClient(clientOrConfig);
    }

    var service = Object.create(ServicePrototype);
    service.client = client;
    return service;
  };
}

exports = createServiceFactory;
export default exports;